import { FC } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { ModalDialog } from 'core-components/library/modalDialog'

// TODO: Moved to common components
import { SelectPartnerTable } from '../../../../onboarding/requestsInfo/requestTypes/SelectPartnerTable'

import { ISelectPartnerDialogProps } from './models'

export const SelectPartnerDialog: FC<ISelectPartnerDialogProps> = ({
  isVisible,
  onClose,
  onSelect,
}) => (
  <ModalDialog
    show={isVisible}
    size="xl"
    onClose={onClose}
    content={() => (
      <SelectPartnerTable
        disableEditAction
        onboardingTable
        sourceKey="SalesTeam"
        onSelect={({ PartnerID, LocationID, PartnerType, CommunicationName, Country, Region }) => {
          if (PartnerID) {
            onSelect({
              partnerId: PartnerID,
              locationId: LocationID,
              region: Region,
              communicationName: CommunicationName,
              country: Country,
              partnerType: PartnerType,
            })
          }
          onClose()
        }}
      />
    )}
  />
)
